// generated by scripts/extract-theme.mts — do not edit manually

export const motion = {
  duration: {
    /**
     * @css-value [var(--motion-duration-slow)](./css/vars/motion.css)
     * @css-source [100ms](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    slow: 'var(--motion-duration-slow)',
    /**
     * @css-value [var(--motion-duration-normal)](./css/vars/motion.css)
     * @css-source [100ms](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    normal: 'var(--motion-duration-normal)',
    /**
     * @css-value [var(--motion-duration-fast)](./css/vars/motion.css)
     * @css-source [100ms](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    fast: 'var(--motion-duration-fast)',
    /**
     * @css-value [var(--motion-duration-micro)](./css/vars/motion.css)
     * @css-source [100ms](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    micro: 'var(--motion-duration-micro)',
  },
  transition: {
    /**
     * @css-value [var(--motion-transition-slow)](./css/vars/motion.css)
     * @css-source [all 100ms ease-in-out](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    slow: 'var(--motion-transition-slow)',
    /**
     * @css-value [var(--motion-transition-normal)](./css/vars/motion.css)
     * @css-source [all 100ms ease-in-out](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    normal: 'var(--motion-transition-normal)',
    /**
     * @css-value [var(--motion-transition-fast)](./css/vars/motion.css)
     * @css-source [all 100ms ease-in-out](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    fast: 'var(--motion-transition-fast)',
    /**
     * @css-value [var(--motion-transition-micro)](./css/vars/motion.css)
     * @css-source [all 100ms ease-in-out](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    micro: 'var(--motion-transition-micro)',
    /**
     * @css-value [var(--motion-transition-slow-partial)](./css/vars/motion.css)
     * @css-source [100ms ease-in-out](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    slow_partial: 'var(--motion-transition-slow-partial)',
    /**
     * @css-value [var(--motion-transition-micro-partial)](./css/vars/motion.css)
     * @css-source [100ms ease-in-out](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    micro_partial: 'var(--motion-transition-micro-partial)',
  },
  curve: {
    /**
     * @css-value [var(--motion-curve-fast-in-out)](./css/vars/motion.css)
     * @css-source [cubic-bezier(0.25, 0, 0.25, 1)](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    fast_in_out: 'var(--motion-curve-fast-in-out)',
    /**
     * @css-value [var(--motion-curve-fast-in)](./css/vars/motion.css)
     * @css-source [cubic-bezier(0.25, 0, 0.5, 1)](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    fast_in: 'var(--motion-curve-fast-in)',
    /**
     * @css-value [var(--motion-curve-ease-in-out)](./css/vars/motion.css)
     * @css-source [ease-in-out](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    ease_in_out: 'var(--motion-curve-ease-in-out)',
    /**
     * @css-value [var(--motion-curve-ease-in)](./css/vars/motion.css)
     * @css-source [ease-in](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    ease_in: 'var(--motion-curve-ease-in)',
    /**
     * @css-value [var(--motion-curve-ease-out)](./css/vars/motion.css)
     * @css-source [ease-out](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    ease_out: 'var(--motion-curve-ease-out)',
    /**
     * @css-value [var(--motion-curve-linear)](./css/vars/motion.css)
     * @css-source [linear](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    linear: 'var(--motion-curve-linear)',
    /**
     * @css-value [var(--motion-curve-ease)](./css/vars/motion.css)
     * @css-source [ease](./css/vars/motion.css)
     * @see [./css/vars/motion.css](./css/vars/motion.css)
     */
    ease: 'var(--motion-curve-ease)',
  },
} as const;

export type Motion = typeof motion;
